import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  DASHBOARD,
  REPORT_DASHBOARD,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'dashboard' })
export default class Dashboard extends VuexModule {
  dashboard: any = {};

  dashboardReport: any = [];

  @Mutation
  mutateDashboard(dashboard) {
    this.dashboard = dashboard;
  }

  @Action({ commit: 'mutateDashboard' })
  FetchDashboard(params) {
    return Vue.axios({
      url: BASE_URL + DASHBOARD,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const dashboard = data.data;
          return dashboard;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateDashboardReport(dashboardReport) {
    this.dashboardReport = dashboardReport;
  }

  @Action({ commit: 'mutateDashboardReport' })
  FetchDashboardReport() {
    return Vue.axios({
      url: BASE_URL + REPORT_DASHBOARD,
      method: M_POST,
      data: {},
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const dashboardReport = data.data;
          return dashboardReport;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
